import React, { useState } from "react";

export default function TechnologyUsed({ data }) {
  const limit = 15;
  const [less, setLess] = useState(true);
  const toggleLess = () => {
    setLess(!less);
  };
  return (
    <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <span className="text-[16px] text-text-700 mr-3 font-bold">
          Technology Used
        </span>
      </div>
      <div className="px-4 mb-4">
        {data &&
          data &&
          data.length > 0 &&
          data
            .slice(0, less ? limit : data.length)
            .map((item) => (
              <span className="inline-block text-[12px] bg-background text-gray-blue-700 border border-gray-blue-700 px-2 py-1 rounded-[20px] mr-3 mb-3">
                {item}
              </span>
            ))}
        {data && data && data.length > 0 && limit < data.length && (
          <div>
            <span
              onClick={toggleLess}
              className="text-brand-700 font-bold text-sm inline-block mt-1 cursor-pointer"
            >
              {less ? "See more" : "See less"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
